import { AgentBlocksTextProvider } from '@fluenceur/agent-blocks';
import type { ReactNode } from 'react';
import { useAgentBlocksText } from './use-agent-blocks-text';

/** Mounts the dashboard's translations above any companion block. */
export function AgentBlocksTextBridge({ children }: { children: ReactNode }) {
  const text = useAgentBlocksText();
  return <AgentBlocksTextProvider value={text}>{children}</AgentBlocksTextProvider>;
}
